import {SearchComponent} from '../search';
import React from 'react';
import {SearchPageType} from '../search-config';
import {useSynchronizeSearchFromUrl} from '../search-hooks';
import {DefaultRootState, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {useTranslationsRequest} from '../../backendTranslations/backendTranslations-service';

export const SearchPage = React.memo(() => {
    const searchConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.search);
    const location = useLocation();
    const navigate = useNavigate();

    if (!searchConfig.enabled) {
        navigate('/');
    }

    useTranslationsRequest();
    useSynchronizeSearchFromUrl(SearchPageType.BASIC, !!location.state?.comingFromLandingPage);

    return (
        <SearchComponent
            searchPageType={SearchPageType.BASIC}
        />
    );
});
